import React from 'react';
import styled from 'styled-components';
import Cell from './Cell';
import { COLORS, BOARD_WIDTH, BOARD_HEIGHT, CELL_SIZE } from '../utils/constants';

const StyledBoard = styled.div`
  display: grid;
  grid-template-rows: repeat(${BOARD_HEIGHT}, ${CELL_SIZE}px);
  grid-template-columns: repeat(${BOARD_WIDTH}, ${CELL_SIZE}px);
  grid-gap: 0;
  border: 2px solid #333;
  background: #111;
  width: ${BOARD_WIDTH * CELL_SIZE}px;
  max-width: 100%;
  height: ${BOARD_HEIGHT * CELL_SIZE}px;
`;

const Board = ({ board, activeTetromino }) => {
  // 创建一个包含活动方块的临时游戏板用于显示
  const renderBoard = [...board.map(row => [...row])];
  
  // 将活动方块添加到渲染游戏板中
  if (activeTetromino) {
    const { shape, x, y, colorIndex } = activeTetromino;
    
    // 遍历方块形状，将其添加到渲染游戏板
    for (let row = 0; row < shape.length; row++) {
      for (let col = 0; col < shape[row].length; col++) {
        if (shape[row][col] !== 0) {
          const boardY = y + row;
          const boardX = x + col;
          
          // 确保只渲染在游戏板内的方块
          if (
            boardY >= 0 && 
            boardY < BOARD_HEIGHT && 
            boardX >= 0 && 
            boardX < BOARD_WIDTH
          ) {
            // 使用 colorIndex + 1 作为类型值，colorIndex 从 0 开始
            renderBoard[boardY][boardX] = colorIndex + 1;
          }
        }
      }
    }
  }
  
  return (
    <StyledBoard>
      {renderBoard.map((row, y) =>
        row.map((cell, x) => (
          <Cell key={`${y}-${x}`} type={cell} colors={COLORS} />
        ))
      )}
    </StyledBoard>
  );
};

export default Board;